import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import Layout from "../components/layouts/Layout";

type Props = {
    children: React.ReactNode;
    redirectLink?: string;
    title?: string;
    headline?: string;
};

function ProtectedRouteOrganization({ children, redirectLink, title = "Organization", headline = "" }: Props) {
    const { accessToken, role } = useSelector((state: RootState) => state.auth);

    const location = useLocation();

    const currentPath = encodeURIComponent(location.pathname + location.search);

    if (role === "ORGANIZATION" && accessToken) {
        return (
            <Layout title={title} headline={headline}>
                {children}
            </Layout>
        );
    }

    if (role === "ADMIN") return <Navigate to="/admin" replace />;
    if (role === "ORGANIZER") return <Navigate to="/organizer" replace />;
    if (role === "STORE") return <Navigate to="/store/dashboard" replace />;
    if (role === "OWNER") return <Navigate to="/owner" replace />;
    if (role === "CUSTOMER") return <Navigate to="/" replace />;

    return (
        <Navigate
            to={redirectLink ? redirectLink : `/organization/login?redirect=${currentPath}`}
            replace
        />
    );
}

export default ProtectedRouteOrganization;
